export const TIMELINE_EVENTS = [
  { key: 'patientLoggedTime', name: 'Patient joined consultation' },
  { key: 'doctorLoggedTime', name: 'Doctor joined consultation' },
  { key: 'prescriptionCreatedTime', name: 'Prescription created', conditionKey: 'isPrescriptionCreated' },
  { key: 'prescriptionProposedTime', name: 'Prescription proposed', proposerKey: 'prescriptionProposedBy' },
  { key: 'prescriptionApprovedTime', name: 'Prescription approved' },
  { key: 'referralLetterCreatedTime', name: 'Referral letter created', conditionKey: 'isReferralLetterCreated' },
  { key: 'referralLetterProposedTime', name: 'Referral letter proposed', proposerKey: 'referralLetterProposedBy' },
  { key: 'referralLetterApprovedTime', name: 'Referral letter approved' },
  { key: 'fitNoteCreatedTime', name: 'Fit note created', conditionKey: 'isFitNoteCreated' },
  { key: 'fitNoteProposedTime', name: 'Fit note proposed', proposerKey: 'fitNoteProposedBy' },
  { key: 'fitNoteApprovedTime', name: 'Fit note approved' },
  // Payment rows: the time is set on every attempt, so the label comes from the status (see paymentEventName).
  { key: 'documentPaymentTime', name: 'Additional services payment', statusKey: 'documentPaymentStatus' },
  { key: 'prescriptionIssuedTime', name: 'Prescription issued' },
  { key: 'referralLetterIssuedTime', name: 'Referral letter issued' },
  { key: 'fitNoteIssuedTime', name: 'Fit note issued' },
  { key: 'deliveryPaymentTime', name: 'Home Delivery Payment', statusKey: 'deliveryPaymentStatus' },
  { key: 'medicationPaymentTime', name: 'Medication Payment', statusKey: 'medicationPaymentStatus' },
  { key: 'deliveryAddressUpdateTime', name: 'Delivery Address Updated', proposerKey: 'prescriptionProposedBy' },
];

const PAID_STATUSES = ['CAPTURED', 'PAID', 'SUCCEEDED', 'SUCCESS', 'COMPLETED', 'PRE-AUTHORIZED', 'PRE-AUTHORISED'];
const COUPON_STATUSES = ['COUPON', 'GB-COUPON', 'GB COUPON', 'GBB-COUPON'];

/** "Medication Payment" + status -> label and tone (ok | failed | pending) for the history row. */
export function paymentEventName(baseName, status) {
  const s = String(status || '').toUpperCase();
  if (s === 'FAILED') return { name: `${baseName} Failed`, tone: 'failed' };
  if (s === 'PENDING' || s === 'REQUIRES_ACTION' || s === 'PROCESSING') return { name: `${baseName} Pending`, tone: 'pending' };
  if (COUPON_STATUSES.includes(s)) return { name: `${baseName} Covered by Coupon`, tone: 'ok' };
  if (PAID_STATUSES.includes(s)) return { name: `${baseName} Completed`, tone: 'ok' };
  return { name: status ? `${baseName} (${status})` : `${baseName} Attempted`, tone: 'pending' };
}

/** Parses API times, including Java ZonedDateTime text like "2026-09-25T09:05:12.3+01:00[Europe/London]". */
export function parseApiTime(value) {
  if (!value) return null;
  const d = new Date(String(value).replace(/\[[^\]]*\]$/, ''));
  return isNaN(d.getTime()) ? null : d;
}
